(function(){
    'use strict';

    angular.module('elogbooks.admin.permissions-overview', []);
})();